import React from 'react';
import { useParams } from 'react-router-dom';

const IframeDisplay = () => {
    const { iframeLink } = useParams();

    return (
        <div className="IframeContainer">
            <iframe
                src={decodeURIComponent(iframeLink)}
                title="Project Display"
                frameBorder="0"
                style={{ width: '100%', height: '100vh' }}
                allowFullScreen
            ></iframe>
        </div>
    );
};

export default IframeDisplay;
